/* hs-eslint ignored failing-rules */
'use es6';

import ActionTypes from './ActionTypes';
import { getFilters } from '../features/filters';
import { OrderedSet, Set as ImmutableSet } from 'immutable';

function filtersRequesting() {
  return {
    type: ActionTypes.FILTERS_REQUESTING
  };
}

function filtersReceived(filters) {
  return {
    type: ActionTypes.FILTERS_RECEIVED,
    payload: {
      categories: OrderedSet(filters.categories),
      topics: ImmutableSet(filters.topics),
      products: ImmutableSet(filters.products),
      subCategories: ImmutableSet(filters.subCategories),
      hsSoftwareFilters: ImmutableSet(filters.hsSoftwareFilters),
      levelFilters: ImmutableSet(filters.levelFilters)
    }
  };
}

function filtersRequestError(error) {
  return {
    type: ActionTypes.FILTERS_ERROR,
    error: true,
    payload: error
  };
}

export function fetchFilters() {
  return dispatch => {
    dispatch(filtersRequesting());
    getFilters().then(response => dispatch(filtersReceived(response)), errorResponse => dispatch(filtersRequestError(errorResponse))).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}
export function fetchFiltersIfNeeded() {
  return (dispatch, getState) => {
    const filtersState = getState().filters;

    if (!filtersState.get('lastValidResult')) {
      dispatch(fetchFilters());
    }
  };
}